"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _createSvgIcon = _interopRequireDefault(require("../utils/createSvgIcon"));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M40 20c0 11.046-8.954 20-20 20S0 31.046 0 20 8.954 0 20 0s20 8.954 20 20",
  fill: "#46BDDB",
  mask: "url(#b)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.23 13.077h21.54V10H9.23z",
  fill: "#DC2049",
  mask: "url(#d)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.23 13.077v15.385h21.54V13.077z",
  fill: "#EFEDED",
  mask: "url(#d)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.23 20.77h21.54v-7.693H9.23zM9.23 28.462h21.54V20.77H9.23z",
  fill: "#FFF",
  mask: "url(#d)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.308 14.423a.769.769 0 0 1-.77-.769V12.5a.769.769 0 1 1 1.539 0v1.154a.769.769 0 0 1-.77.77M27.692 14.423a.769.769 0 0 1-.769-.769V12.5a.769.769 0 1 1 1.538 0v1.154a.769.769 0 0 1-.769.77",
  fill: "#242C3D",
  mask: "url(#d)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.23 30h21.54v-1.538H9.23z",
  fill: "#C2C4C6",
  mask: "url(#d)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m12.308 18.077h1.538v-1.537h-1.538zm2.308 0h1.538v-1.537h-1.538z",
  fill: "#DE2757",
  mask: "url(#d)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m16.923 18.077h1.538v-1.537h-1.538zm2.307 0h1.54v-1.537h-1.54zm2.309 0h1.538v-1.537h-1.537z",
  fill: "#ABADB3",
  mask: "url(#d)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m12.308 20.385h1.538v-1.539h-1.538zm0 2.307h1.538v-1.538h-1.538zm2.308-2.307h1.538v-1.539h-1.538z",
  fill: "#DE2757",
  mask: "url(#d)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m16.923 20.385h1.538v-1.539h-1.538zm2.307 0h1.54v-1.539h-1.54zm2.309 0h1.538v-1.539h-1.537zm2.307 0h1.538v-1.539h-1.538zm2.308 0h1.538v-1.539h-1.538z",
  fill: "#ABADB3",
  mask: "url(#d)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m14.616 22.692h1.538v-1.538h-1.538z",
  fill: "#DE2757",
  mask: "url(#d)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m16.923 22.692h1.538v-1.538h-1.538zm2.307 0h1.54v-1.538h-1.54zm2.309 0h1.538v-1.538h-1.537zm2.307 0h1.538v-1.538h-1.538zm2.308 0h1.538v-1.538h-1.538zm-9.231 2.308h1.538v-1.538h-1.538zm2.307 0h1.54v-1.538h-1.54zm2.309 0h1.538v-1.538h-1.537zm2.307 0h1.538v-1.538h-1.538zm2.308 0h1.538v-1.538h-1.538z",
  fill: "#ABADB3",
  mask: "url(#d)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.77 10v20H9.23l9.984 9.983c.262.01.523.017.786.017 11.046 0 20-8.954 20-20 0-.263-.007-.525-.017-.786L30.769 10z",
  fill: "#009CC6",
  mask: "url(#d)"
})), 'ExtendedWarranty', {
  viewBox: '0 0 40 40'
});

exports.default = _default;